import React from 'react';
import { DataPackageV2Component } from '@vivli/shared/features/data-package/components';
import { useUserPermissions } from '@vivli/features/users/infrastructure/hook';
import { IDataPackage, IDataPackageFileDescriptor } from '@vivli/shared/features/data-package/infrastructure/interface';

interface DownloadOnlyDataPackageFeatureProps {
    dataPackageId?: string;
    //data package id for study IPD package
    secondaryDataPackageId?: string;
    overrideDataPackage?: IDataPackage;
    datasetMetaDataDoi?: string;
    studyOrgId?: string;
    onReady?: () => void;
    onClose?: () => void;
    disallowDownload?: boolean;
    showPubliclyAvailable?: boolean;
    showFileType?: boolean;
    hideUploadedBy?: boolean;
    hideSize?: boolean;
    hideForPubliclyAvailableTypes?: any[];
    requiredTypes?: string[];
    availableTypes?: any[];
    title?: string;
    onDataPackageLoaded?: (dataPackage: IDataPackage) => void;
    secondaryFilesToShow?: IDataPackageFileDescriptor[];
    onSecondaryDataPackageUpdated?: (dataPackage: IDataPackage) => void;
    onPackageUpdated?: (dataPackage: IDataPackage) => void;
}

export const DownloadOnlyDataPackageFeature = ({
    dataPackageId,
    secondaryDataPackageId,
    datasetMetaDataDoi,
    studyOrgId,
    onReady,
    onClose,
    disallowDownload,
    showPubliclyAvailable,
    showFileType,
    hideUploadedBy,
    hideSize,
    availableTypes,
    requiredTypes,
    hideForPubliclyAvailableTypes,
    title,
    onDataPackageLoaded,
    secondaryFilesToShow,
    onSecondaryDataPackageUpdated,
    overrideDataPackage,
    onPackageUpdated
}: DownloadOnlyDataPackageFeatureProps) => {
    const { studyPermissions } = useUserPermissions();

    return (
        <DataPackageV2Component
            allowPubliclyAvailableEdit={studyPermissions.canModifyPubliclyAvailable(studyOrgId)}
            dataPackageId={dataPackageId}
            secondaryDataPackageId={secondaryDataPackageId}
            readOnly={true}
            allowDownload={!disallowDownload}
            allowUpload={false}
            allowSubmit={false}
            // DEV-486: file type used to be derived from showPubliclyAvailable, which conflated two
            // unrelated concerns -- only the admin Data Package tab passes that flag, so every
            // researcher-facing screen silently lost the column. Each call site now opts in on its own.
            showFileType={showFileType}
            showPubliclyAvailable={showPubliclyAvailable}
            hideUploadedBy={hideUploadedBy}
            hideSize={hideSize}
            onReady={onReady}
            datasetMetaDataDoi={datasetMetaDataDoi}
            studyOrgId={studyOrgId}
            recordFileDownload={true}
            onClose={onClose}
            requiredTypes={requiredTypes}
            availableTypes={availableTypes}
            hideForPubliclyAvailableTypes={hideForPubliclyAvailableTypes}
            title={title}
            onDataPackageLoaded={onDataPackageLoaded}
            secondaryFilesToShow={secondaryFilesToShow}
            onSecondaryDataPackageUpdated={onSecondaryDataPackageUpdated}
            overrideDataPackage={overrideDataPackage}
            onPackageUpdated={onPackageUpdated}
        />
    );
};
